import styled from 'styled-components'
import { currentTheme, testTheme, theme } from '../../Styles'

export const FooterCont = styled.div`
    display: flex;
    text-align: center;
    justify-items: center;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    min-height: 80px;
    max-height: auto;
    margin-left: 0px; 
    margin-right: 0px;
    background: ${theme.main};
    border-top: 1px solid ${theme.secondary};
    padding-top: 15px;
    

    color: ${theme.textMain};


`